import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { INTERNSHIPS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/internships/new")({
  component: () => <DeptContentForm cfg={INTERNSHIPS} />,
});
